/**
 * Usage:
 * import { renderElement } from '@local_modules/generic/dom/render-element.js'
 *
 * @param {String} containerId
 * @param {Element} element
 */
export function renderElement (containerId, element) {
  const containerElement = document.getElementById(containerId)
  if (!containerElement) return

  // Empty the container first:
  containerElement.innerHTML = ''

  // Set the content
  containerElement.appendChild(element)
}
